/** Canonical public site origin used for links shared with clients (QR codes, emails). */
export const PUBLIC_SITE_URL = 'https://riham.co.il';

export function publicUrl(path: string): string {
  return `${PUBLIC_SITE_URL}${path.startsWith('/') ? path : `/${path}`}`;
}
